import React from 'react';

import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Box, Tag, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { TextBlock } from '@bcp-nextgen-dx-component-factory/design-system';

import { GlobalTag } from '../globalTag';
import { SimulationCardHeaderProps } from './simulationCardHeader';

export const SimulationCardHeaderAb: React.FC<SimulationCardHeaderProps> = (props: SimulationCardHeaderProps) => {
	const { term, value, label } = props;
	const translate = useTranslation();

	return (
		<Box
			styles={{
				flexDirection: 'column',
				padding: '16px 0',
				borderRadius: '8px',
				background: '#F5F8F9',
				alignItems: 'center',
			}}
		>
			<Box styles={{ width: '100%', justifyContent: 'center', gap: '16px' }}>
				<GlobalTag
					size="48px"
					description={
						<div>
							<Typography appearance={'body-100-07'} colorToken="primary-light">
								{term}x
							</Typography>
						</div>
					}
				/>
				<TextBlock.Currency
					size="medium"
					fontWeight="strong"
					currency={translate('simulator.dataDisplay.eurosPerMonth')}
					floatValue={value}
				/>
			</Box>
			{label && (
				<Typography colorToken="primary-light" appearance="body-100-01">
					{label}
				</Typography>
			)}
		</Box>
	);
};
